

if(!process.env.REACT_APP_ENV){
    throw 'process.env.REACT_APP_ENVが選定されてません'
}
export const isStaging = process.env.REACT_APP_ENV === 'staging'

export const baseUrl = process.env.REACT_APP_BASE_URL
